export default __webpack_public_path__ + "static/media/4.eae0212f.svg";